module.exports = __webpack_public_path__ + "static/img/450-318.891edcb5.jpg";